import { render, staticRenderFns } from "./plashScreen.vue?vue&type=template&id=7bb07157&"
import script from "./plashScreen.vue.ts?vue&type=script&lang=ts&"
export * from "./plashScreen.vue.ts?vue&type=script&lang=ts&"
import style0 from "./plashScreen.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports